import axios from "axios";
import { logOut } from "../../helperFunctions";

export const getClusters = (setClusters, state, setState, history) => {
  const userEmail = JSON.parse(localStorage.getItem("wcsUserEmail")); //email of the logged in user
  const access_token = JSON.parse(localStorage.getItem("access_token"));

  axios
    .get(window.consoleConfig.wcs + "/v1/clusters/list?email=" + encodeURIComponent(userEmail), {
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
    .then((res) => {
      setClusters(res); // setting state with the response so components can access it
    })
    .catch((err) => {
      console.log(err);
      logOut(setState, state, history);
    });
};

//sets a CSS property which then sets the color of the name input adornment
export const setCSSVariable = (state) => {
  let root = document.documentElement;

  if (state.theme === "dark") {
    root.style.setProperty("--text-color-create-cluster-form", "#ababab");
    root.style.setProperty("--background-color-info-text-box-create-cluster-form", "#213957");
    root.style.setProperty("--border-color-info-text-box-create-cluster-form", "#7285a7");
    root.style.setProperty("--text-color-info-text-box-create-cluster-form", "#d1d1d1");
    root.style.setProperty("--link-bottom-info-text-box-create-cluster-form", "#fa0171");
  } else {
    root.style.setProperty("--text-color-create-cluster-form", "#00152b");
    root.style.setProperty("--background-color-info-text-box-create-cluster-form", "#bcf0a7");
    root.style.setProperty("--border-color-info-text-box-create-cluster-form", "#38d611");
    root.style.setProperty("--text-color-link-info-text-box-create-cluster-form", "#fa0171");
    root.style.setProperty("--link-bottom-info-text-box-create-cluster-form", "#fa0171");
  }
};

export const getEnterpriseToken = () => {
  //get enterprise usage token when WCS module is first loaded
  //only works if user is logged in through the WCS module
  // reverse engineered this code from the old console
  axios({
    method: "post",
    url: window.consoleConfig.enterpriseTokenCollector,
    data: JSON.stringify({
      Bearer: JSON.parse(window.localStorage.getItem("access_token")),
    }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      localStorage.setItem("wcsEnterpriseToken", JSON.stringify(response.data)); // saves the enterprise token in local storage so the pop up can read it
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getIndividualClusterInfo = (clustersListUrl, access_token, setClusterInfo) => {
  // This runs every few seconds when the WCS module is displayed
  // it gets current statuses for each cluster so the user always sees the current status of the cluster
  axios({
    method: "get",
    url: clustersListUrl,
    headers: {
      authorization: `Bearer ${access_token}`,
      // origin: window.origin, //for cors policy
    },
  })
    .then((res) => {
      setClusterInfo(res); //updates state every time it's run
    })
    .catch((err) => {
      console.log(err);
      console.log(err.response);
    });
};

export const deleteIndividualCluster = (setClusters, clusters, clusterInfo, history, state, setState) => {
  const clustersListUrl = `${window.consoleConfig.wcs}/v1/clusters/${clusterInfo.data.id}`;
  const access_token = JSON.parse(localStorage.getItem("access_token"));

  //this makes sure that if you delete a cluster that is currently connected
  //the Weaviate status display on the top bar will switch to 'Disconnected' status
  const weaviateURI = JSON.parse(localStorage.getItem("connectToWeaviateURI"));
  if (weaviateURI.includes(clusterInfo.data.meta.PublicURL)) {
    localStorage.setItem("connectToWeaviateURI", JSON.stringify(""));
    setState({
      ...state,
      isWeaviateURIDisconnected: true,
      connectToWeaviateURI: "",
    });
  }

  //If you delete the only available cluster, then it will take you straight to empty
  // clusters page and prompt you to create your first one
  if (clusters.data.clusterIDs.length === 1) {
    history.push("/console/wcs/add-cluster");
  }

  //Deletes the cluster from the application state so that the user
  //can see the cluster being deleted immediately
  const filteredArray = clusters.data.clusterIDs.filter((id) => id !== clusterInfo.data.id);

  setClusters({
    ...clusters,
    data: { ...clusters.data, clusterIDs: filteredArray },
  });

  //request to delete the cluster
  axios({
    method: "delete",
    url: clustersListUrl,
    headers: {
      authorization: `Bearer ${access_token}`,
      origin: window.origin,
    },
  })
    .then((res) => {})
    .catch((err) => {
      console.log(err);
      logOut(setState, state, history);
    });
};

//function for fetching api get
export const fetchAPI = (url, callback) => {
  axios
    .get(url)
    .then((response) => {
      callback(undefined, response);
    })
    .catch((err) => {
      callback(err, undefined);
    });
};

export const getNextURL = (optionInfo, userInput) => {
  const { href } = optionInfo.next;
  const { name, present } = optionInfo;

  if (!present) {
    return href;
  }

  return `${href}&${name}=${userInput}`;
};

//function for creating a new cluster
export const createNewCluster = (clusterState, setClusterState, history) => {
  //handles cluster name verification. Errors out if not correct and
  //displays the error to the user
  if (clusterState.name && !clusterState.name[0].match(/[a-z]/i)) {
    setClusterState({
      ...clusterState,
      errorMessage: "Cluster name must start with a letter",
    });
  } else {
    //shows to the user that it's in thr works
    setClusterState({ ...clusterState, isSubmitButtonLoading: true });

    //getting info from localStorage for the request body
    const url = `${window.consoleConfig.wcs}/v1/clusters`;
    const userEmail = window.localStorage.getItem("wcsUserEmail");
    const accessToken = window.localStorage.getItem("access_token");

    //request body object reverse engineered from old console
    const dataObj = {
      email: JSON.parse(userEmail),
      configuration: clusterState.payloadData.data.cluster.configuration,
    };

    // // conditional fields depending on user decisions

    if (clusterState.name !== "") {
      dataObj.id = clusterState.name;
    }

    axios({
      method: "post",
      url: url,
      data: JSON.stringify(dataObj),
      headers: {
        authorization: `Bearer ${JSON.parse(accessToken)}`,
        "Content-Type": "application/json",
        origin: window.origin, //for cors policy
      },
    })
      .then((response) => {
        //if the user wants to have the demo dataset
        if (clusterState.dataInitialization === "true") {
          const data = {
            dataset: "newspublications",
          };

          const requestURL = `${window.consoleConfig.wcs}/v1/clusters/${response.data.id}/jobs`;

          const access_token = JSON.parse(window.localStorage.getItem("access_token"));

          axios({
            method: "post",
            url: requestURL,
            data: JSON.stringify(data),
            headers: {
              authorization: `Bearer ${JSON.parse(access_token)}`,
              "Content-Type": "application/json",
              origin: window.origin, //for cors policy
            },
          })
            .then((res) => {
              // Once dataset import is initialized, state is updated

              setClusterState({
                name: "",
                nameEnd: ".weaviate.network",
                wcsConfigStep: 1,
                wcsConfigData: [],
                configComplete: false,
                isSelectOpen: false,
                payloadData: null,
                isSubmitButtonLoading: false,
              });
            })
            .catch((err) => console.log(err.response.data.description));
        } else {
          //if successful and no dataset wanted, it updates the state right away

          setClusterState({
            name: "",
            nameEnd: ".weaviate.network",
            wcsConfigStep: 1,
            wcsConfigData: [],
            configComplete: false,
            isSelectOpen: false,
            payloadData: null,
            isSubmitButtonLoading: false,
          });
        }

        //pushes to clusters view page... spinner is displayed until data is received
        history.push("/console/wcs/clusters");
      })
      .catch((err) => {
        if (err.response) {
          // Request made and server responded
          //if there is an error, state is updated
          //and error is displayed to the user. Not possible to proceed until error is fixed
          setClusterState({
            ...clusterState,
            errorMessage: err.response.data.description,
            isSubmitButtonLoading: false,
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", err.message);
        }
      });
  }
};

//if user clicks on cancel instead of 'create', this function will run
//and it will take user back to initial page if no clusters exist
//or to clusters view page if the user has any cluster
export const cancelNewCluster = (setClusterState, history, setState, state) => {
  const userEmail = JSON.parse(localStorage.getItem("wcsUserEmail")); //email of the logged in user
  const access_token = JSON.parse(localStorage.getItem("access_token"));

  axios
    .get(window.consoleConfig.wcs + "/v1/clusters/list?email=" + encodeURIComponent(userEmail), {
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
    .then((res) => {
      if (res.data.clusterIDs === null || res.data.clusterIDs.length === 0) {
        history.push("/console/wcs/add-cluster");
      } else {
        history.push("/console/wcs/clusters");
      }

      setClusterState({
        name: "",
        nameEnd: window.consoleConfig.wcsInstancePublicSubdomain,
        errorMessage: "",
        isSubmitButtonLoading: false,
        wcsConfigStep: 1,
        wcsConfigData: [],
        configComplete: false,
        isSelectOpen: false,
        payloadData: null,
      });
    })
    .catch((err) => {
      console.log(err);
      logOut(setState, state, history);
    });
};

//function is run when user connects to a new cluster
export const connectCluster = (state, setState, clusterInfo) => {
  const authenticationChecker = () => {
    if (!clusterInfo.data.configuration.requiresAuthentication) {
      return false;
    } else {
      return true;
    }
  };

  if (state.connectToWeaviateURI !== `https://${clusterInfo.data.meta.PublicURL}`) {
    localStorage.setItem("connectToWeaviateURI", JSON.stringify(`https://${clusterInfo.data.meta.PublicURL}`));

    //updates state with depending on which cluster is connected to
    setState({
      ...state,
      connectToWeaviateURI: `https://${clusterInfo.data.meta.PublicURL}`,
      isWeaviateURIDisconnected: false,
      isWeaviateAuthenticated: authenticationChecker(),
    });

    if (!clusterInfo.data.configuration.requiresAuthentication) {
      localStorage.setItem("isWeaviateAuthenticated", JSON.stringify(false));
    } else {
      localStorage.setItem("isWeaviateAuthenticated", JSON.stringify(true));
    }
  } else {
    localStorage.setItem("connectToWeaviateURI", JSON.stringify(""));

    setState({
      ...state,
      connectToWeaviateURI: "",
      isWeaviateURIDisconnected: true,
    });
  }
};
